import { render } from "./Bnr.vue?vue&type=template&id=396baeec&scoped=true"
import script from "./Bnr.vue?vue&type=script&lang=js"
export * from "./Bnr.vue?vue&type=script&lang=js"

import "./Bnr.vue?vue&type=style&index=0&id=396baeec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396baeec"],['__file',"src/js/components/Bnr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "396baeec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('396baeec', __exports__)) {
    api.reload('396baeec', __exports__)
  }
  
  module.hot.accept("./Bnr.vue?vue&type=template&id=396baeec&scoped=true", () => {
    api.rerender('396baeec', render)
  })

}


export default __exports__